import styled from 'styled-components'

import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const InfoSection = styled.div`
  width: inherit;
  display: flex;
  align-items: center;
  margin-top: auto;
  margin-bottom: 28px;
  z-index: 1;
  padding: 8px 0;

  ${Media.Phone`
    width: 100%;
    position: fixed;
    bottom: 77px;
    margin-bottom: 0;
    background-color: ${Colors.White};
    justify-content: center;
  `}
`

export const InfoSectionIcon = styled.div`
  fill: white;
  color: ${Colors.Neutral50};
  padding-right: 4px;
  display: flex;
  align-items: center;
`

export const InfoSectionDescription = styled.div`
  color: ${Colors.Neutral50};
  ${Typography.Caption}
  ${FontWeights.Regular}
`

export const InfoSectionDescriptionBold = styled.span`
  color: ${Colors.Neutral90};
  ${Typography.Caption}
  ${FontWeights.Medium}
`
